<template>
  <div class="current-master" :class="{'is-active': isActive}">
    <div class="current-master__info">
      <div class="current-master__how">Время выполнения услуги: {{serviceDuration}}</div>
      <div class="current-master__mobile-data">
        <img
          v-if="master && master.photo != null"
          :src="SERVER_URL+master.photo"
          alt
          class="current-master__mobile-img"
        >
        <img v-else alt src="../../assets/img/Group_2.svg" class="current-master__mobile-img">
        <div class="current-master__mobile-info">
          <h3 v-if="master" class="current-master__mobile-name">{{master.full_name}}</h3>
          <div class="current-master__mobile-serv">{{serviceName}}</div>
        </div>
      </div>
      <div class="current-master__mobile-tabs">
        <span class="current-master__mobile-tab" :class="{'is-active': isActiveTab}" data-id="tab-1" @click="onTabClick()">Запись</span>
        <span class="current-master__mobile-tab" :class="{'is-active': !isActiveTab}" data-id="tab-2" @click="onTabClick()">График работы</span>
        <!--<span class="current-master__mobile-tab" data-id="tab-3">О себе</span>-->
      </div>
      <div class="current-master__tab-wrap">
        <div class="current-master__today current-master__tab-item" :class="{'is-active': isActiveTab}" id="tab-1">
          <!--<h2 class="current-master__title">Записаться на сегодня</h2>-->

          <FreeTimeAll v-if="serviceInProgress.masterId" @onClickAllow="onClickAllow" />
        </div>
        <div class="current-master__schedule current-master__tab-item" :class="{'is-active': !isActiveTab}" id="tab-2">
          <h2 class="current-master__title" :class="{'is-active': scheduleIsActive}" @click="onShow">
            График работы
            <i class="material-icons">chevron_right</i>
          </h2>
          <div class="current-master__wrap js-hidden" :class="{'is-active': scheduleIsActive}">
            <!-- <div class="current-master__days"> -->
            <div v-for="(worktime, index) in times" class="current-master__days" :key="index">
              <span>{{worktime.date}}</span>
              <span>{{worktime.dayName}}</span>
              {{worktime.startTime}} - {{worktime.endTime}}
            </div>
            <!-- </div> -->
            <!-- <div class="current-master__days-wrap">
              <div v-for="(worktime, index) in times" class="current-master__days" :key="index">
                <span>{{worktime.date}}</span>
                <span>{{worktime.dayName}}</span>
                {{worktime.startTime}} - {{worktime.endTime}}
              </div>
            </div>-->
          </div>
        </div>
        <!--<div class="current-master__about current-master__tab-item" id="tab-3">-->
        <!--<h2 class="current-master__title">-->
        <!--О себе-->
        <!--<i class="material-icons">chevron_right</i>-->
        <!--</h2>-->
        <!--<p class="current-master__text js-hidden">{{masterDescription}}</p>-->
        <!--</div>-->
      </div>
    </div>
    <div class="current-master__side">
      <button class="current-master__back" type="button" @click="$emit('onClickBack')">
        Назад
        <i class="material-icons">close</i>
      </button>
      <div class="current-master__calendar"></div>
      <div class="current-master__buttons">
        <button class="current-master__cancel" @click="$emit('onClickBack')" type="button">Отменить</button>
        <router-link
          :to="`/company/${cid}/${sid}/client-confirm`"
          class="current-master__next"
          :class="{'is-disabled': currentMasterNext}"
          @click.native="saveService"
        >Далее</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import FreeTimeAll from "@/components/FreeTimeAll.vue";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
const dayNames = ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "CБ", "ВС"];
const normalizeTime = time => time.slice(0, time.lastIndexOf(":"));

export default {
  name: "OneMasterInfo",
  props: ['isActive', 'cid', 'sid'],
  data() {
    return {
      times: [],
      currentMasterNext: true,
      isActiveTab: true,
      scheduleIsActive: false
    };
  },
  components: {
    FreeTimeAll
  },
  methods: {
    ...mapMutations("client", ["saveService"]),
    ...mapActions("salons", ["fetchMasterWorkingTime"]),
    onClickAllow () {
      this.currentMasterNext = false
    },
    onShow () {
      this.scheduleIsActive = !this.scheduleIsActive
    },
    onTabClick () {
      this.isActiveTab = !this.isActiveTab
    }
  },
  computed: {
    ...mapState("client", ["serviceInProgress", "currentSalonId", "companyId"]),
    ...mapGetters("salons", ["getConcreteService", "getMaster"]),

    concreteService() {
      const {
        serviceId,
        subServiceId,
        concreteServiceId,
        concreteServiceLevelId
      } = this.serviceInProgress;

      return this.getConcreteService(
        this.currentSalonId,
        serviceId,
        subServiceId,
        concreteServiceId,
        concreteServiceLevelId
      );
    },

    concreteSubService() {
      const {
        serviceId,
        subServiceId,
        concreteServiceId,
      } = this.serviceInProgress;

      return this.getConcreteService(
        this.currentSalonId,
        serviceId,
        subServiceId,
        concreteServiceId,
      );
    },

    master() {
      const { masterId } = this.serviceInProgress;
      return this.getMaster(this.currentSalonId, masterId);
    },

    serviceDuration() {
      return this.concreteService ? this.concreteService.duration : "";
    },

    masterDescription() {
      return this.master ? this.master.description : "";
    },

    workingTime() {
      if (!this.master) return [];
      return this.master.working_time.map(
        ({ day, start_time, end_time, break_start, break_end }) => ({
          dayName: dayNames[day],
          startTime: normalizeTime(start_time),
          endTime: normalizeTime(end_time),
          breakStart: break_start ? normalizeTime(break_start) : "",
          breakEnd: break_end ? normalizeTime(break_end) : ""
        })
      );
    },
    serviceName() {
      return this.concreteSubService ? this.concreteSubService.name : "";
    }
  },
  watch: {
    master: {
      handler: async function(val, oldVal) {
        if (!val) return;
        const workingTime = await this.fetchMasterWorkingTime({
          masterId: val.id
        });
        this.times = workingTime
          .filter(time => time.start_time !== null)
          .map(time => ({
            date: time.date,
            dayName: dayNames[time.weekday],
            startTime: normalizeTime(time.start_time),
            endTime: normalizeTime(time.end_time)
          }));
      },
      deep: true
    }
  }
};
</script>
